export const sanitizePhone = (value: string): string => value.replace(/[^0-9]/g, "");

export const formatPhone = (value: string): string => {
  const digits = sanitizePhone(value).slice(0, 11);
  if (!digits) {
    return "";
  }

  const area = digits.slice(0, 2);
  if (digits.length <= 2) {
    return `(${area}`;
  }

  if (digits.length <= 6) {
    return `(${area}) ${digits.slice(2)}`;
  }

  if (digits.length <= 10) {
    return `(${area}) ${digits.slice(2, digits.length - 4)}-${digits.slice(-4)}`;
  }

  return `(${area}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
};

export const isValidPhone = (value: string): boolean => {
  const digits = sanitizePhone(value);
  if (!digits) {
    return false;
  }

  return digits.length === 10 || digits.length === 11;
};
